module.exports = __webpack_public_path__ + "img/fixedPlane-mobile.3f1da675.png";